const tokenSeparator = /\s+/;

export function defaultFilterFn<T>(
  { items, labelFn }: { items: T[]; labelFn: (item: T) => string },
  inputValue: string,
) {
  const inputTokens = inputValue.trim().toLocaleLowerCase().split(/\s+/);
  return items.filter((option) => {
    const optionTokens = labelFn(option).trim().toLocaleLowerCase().split(tokenSeparator);
    return inputTokens.every((it) => optionTokens.some((ot) => ot.startsWith(it)));
  });
}
